import _styled from "styled-components";
import type { SanityPageBuilderSection, SanityPageBuilderTextMedia13Section } from "@ouster/shared";
import { up } from "~/features/app/screens";
import { TextMediaBlock1_3View, textMedia1_3RichTextCss } from "~/features/blocks/inventory/text-media1_3";
import { toCraftLinkArray } from "~/features/sanity/link";
import { SanityRichText } from "~/features/sanity/rich-text";
import { useMediaQuery } from "~/features/ui/use-media-query";
import { hasRenderableSanityMedia, SanityMediaFigure } from "./media-figure";
type Props = {
  section: SanityPageBuilderSection & {
    loaded?: boolean;
    sectionContent: SanityPageBuilderTextMedia13Section;
  };
};
export function SanityTextMedia13Section({
  section
}: Props) {
  const {
    sectionContent,
    sectionSettings
  } = section;
  const text = sectionContent.text?.length ? <_StyledSanityRichText value={sectionContent.text} /> : undefined;
  const hasMedia = hasRenderableSanityMedia(sectionContent.media);
  // Below lg the media column has no intrinsic height, so a fixed 3/2 ratio keeps it visible
  // Fit and ratio switch at the large-screen breakpoint.
  const isLg = useMediaQuery(up("lg"));
  return <TextMediaBlock1_3View anchor={{
    id: sectionSettings?.sectionId?.current || sectionSettings?.anchorName || section._key,
    name: sectionSettings?.anchorName
  }} hasTopDivider={sectionSettings?.hasTopDivider ?? true} headline={sectionContent.headline} link={toCraftLinkArray(sectionContent.link)} media={hasMedia ? <SanityMediaFigure fit={isLg ? "cover" : "fill"} media={sectionContent.media} ratio={isLg ? undefined : "3/2"} sizes="lg:33vw" /> : undefined} mediaPosition={sectionContent.mediaPosition} mode={sectionSettings?.mode || "light"} sectionProps={{
    "data-sanity-section-key": section._key,
    "data-sanity-section-type": section._type
  }} text={text} theme={sectionSettings?.theme || "white"} />;
}
var _StyledSanityRichText = /*#__PURE__*/_styled(SanityRichText).withConfig({
  displayName: "text-media1-3___StyledSanityRichText",
  componentId: "sc-1p81u4k-0"
})(["", ""], textMedia1_3RichTextCss);